import formModel from '../../models/form';
import ReducerUtilities from '../../../shared/store/reducer-utilities';
import formCommitTypes from './commit-types';

const INITIAL_FORMS_STATE = {
  isEditingForm: false,
  isLoading: [],
  list: null,
  selectedGuid: null,
};

function dORReducers(state = INITIAL_FORMS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case formCommitTypes.PUSH_FORM:
      return {
        ...state,
        list: [formModel(action.form), ...state.list],
      };
    case formCommitTypes.PUSH_FORMS:
      return {
        ...state,
        list: [...action.list.map(form => formModel(form))],
      };
    case formCommitTypes.REPLACE_FORM:
      return {
        ...state,
        list: ReducerUtilities.replaceModelInList(formModel(action.form), state.list),
      };
    case formCommitTypes.REPLACE_FORMS:
      return {
        ...state,
        list: [
          ...ReducerUtilities.replaceModelsInList(
            action.list.map(item => formModel(item)),
            state.list,
          ),
        ],
      };
    case formCommitTypes.RESET_FORMS_STATE:
      return { ...INITIAL_FORMS_STATE };
    case formCommitTypes.SET_FORMS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    case formCommitTypes.SET_IS_EDITING_FORM:
      return {
        ...state,
        isEditingForm: action.isEditingForm,
      };
    case formCommitTypes.SET_SELECTED_FORM:
      return {
        ...state,
        selectedGuid: action.selectedGuid,
      };
    default:
      return state;
  }
}

export default dORReducers;
